import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppLoaderComponent } from './app-loader.component';

interface Config {
  width?: string
}

@Injectable()
export class AppLoaderService {
  dialogRef: MatDialogRef<AppLoaderComponent>;
  constructor(private dialog: MatDialog) { }

  public open(title: string = 'Processando...', data?:BehaviorSubject<any>, config: Config = {width: '200px'}): Observable<boolean> {
    this.dialogRef = this.dialog.open(AppLoaderComponent, { disableClose: false, backdropClass: 'light-backdrop'});
    this.dialogRef.updateSize(config.width);
    this.dialogRef.componentInstance.title = title;
    if(data != null && data != undefined){
      data?.subscribe((value) => {
      if(value == null){
        return;
      }
      //convert string to json
      value = JSON.parse(value);  
      this.dialogRef.componentInstance.message = value?.message??'';
        console.log(this.dialogRef.componentInstance.message);
        this.dialogRef.componentInstance.progress = value?.progress?(value?.progress??0)*100:-1;
        console.log(this.dialogRef.componentInstance.progress);
        
        if(value.progress === 1){
          this.dialogRef.disableClose = false;
          setTimeout(()=>{              
          this.dialogRef.close();
          }, 5000);
        }

      });
    }
    setTimeout(()=>{                           
      this.dialogRef.disableClose = false;
  }, 60000);
    return this.dialogRef.afterClosed();
  }

  public close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
